"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userPasswordApi = void 0;
const resetPasswordWithVerificationCode = {
    method: "PUT",
    url: "/user/password/reset-with-verification-code",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.userPasswordApi = { resetPasswordWithVerificationCode };
//# sourceMappingURL=userPassword.js.map